import React, { useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    error,
    FORM,
    MAX_NAME,
    REQUIRED,
    selectOption,
} from "../../../components/i18n/i18n";
import Switch from "react-bootstrap-switch";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {routService} from "../../../jwt/_services/clasificator/routService";
import RoutLang from "./_langs";
import {utilHelper} from "../../../jwt/_helpers";
import * as Yup from "yup";
import {MAX_NAME_SIZE} from "../../../components/menu-flower/constants";
import {ErrorMessage, useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

export default function RoutForm(props) {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [status, setStatus] = useState(editMode ? props.item?.status : false);
    const [udn] = useState( editMode ? props.item?.udn : JSON.parse(localStorage.getItem('selectedUdn')) );
    const [langChilds, setLangChilds] = useState([]);
    const [loading, setLoading] = useState(false);
    const refLangs = useRef(null);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME)
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: savedData?.id,
            code: savedData?.code,
            showOrder: savedData?.showOrder,
            description: savedData?.description,
            icon: savedData?.icon,
            colorHex: savedData?.colorHex
        }
    });

    const handleSwitchChange = () => {
        setStatus(!status);
    }

    const onSubmit = (data, _) => {
        if (udn == null)
            return showToastCustom(error, selectOption);

        let dataRequest = {
            showOrder: data.showOrder,
            description: data.description,
            code: data.code,
            icon: data.icon,
            status: status,
            colorHex: data.colorHex,
            colorRgb: utilHelper.hexToRGB(data.colorHex),
            udn: udn,
        };

        if (langChilds != null && langChilds.length !== 0)
            dataRequest.langs = langChilds;

        setLoading(true);

        if (!editMode) {
            //Save
            return routService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;

            dataRequest = { ...dataRequest, id }

            return routService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true)
        refLangs.current.changeDisabledInput(true);
    }

    const resetForm = () => {
        setSavedData(null);
        setStatus(false);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        refLangs.current.resetForm();
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
        refLangs.current.changeDisabledInput(false);
    }

    const updateLangChilds = (langChildsP) => {
        if (langChildsP !== undefined) {
            setLangChilds(langChildsP);
        }
    }

    const setForm = () => {
        props.setForm();
    }


    return (
        <Card>
            {loading ? showLoader() : null}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="id">ID</Label>
                                <Input type="id" name="id" id="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="uid">UID Firebase</Label>
                                <Input type="id" name="uid" id="uid"
                                       disabled
                                       value={editMode ? savedData?.uid : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="code">Código</Label>
                                <Input type="text" name="code"
                                       placeholder=" Código"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="code" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label htmlFor="icon">Ícono</Label>
                                <Input type="text" name="icon"
                                       placeholder=" Código"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label htmlFor="color">Color</Label>
                                <Input type="color" name="colorHex"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label htmlFor="status">Activo</Label><br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        disabled={disableInputs}
                                        onChange={handleSwitchChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardTitle className="border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        Información internacional
                    </CardTitle>
                    <CardBody>
                        <RoutLang
                            ref={refLangs}
                            rout={{id: savedData?.id}}
                            setForm={setForm}
                            updateItem={updateLangChilds}
                            getLangChilds={langChilds}
                            key={"RoutLangId"}
                            editMode={editMode}
                            disableInputs={disableInputs}
                        />
                    </CardBody>
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => {
                                        resetForm()
                                    }}/>
                                    <ButtonEdit onClick={() => {
                                        beginEdit()
                                    }}/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}
